import { lazyLoadView } from '@utils/LazyLoad'
import { SEARCH_GROUPS } from '@constants/Text'

export default [
  {
    path: '/documentos',
    name: 'documents',
    redirect: '/documentos/geral',
    meta: {
      search: {
        title: 'Documentos',
        description: 'Gestão de documentos e contratos',
        keywords: ['documentos', 'contratos', 'arquivos', 'assinaturas'],
        group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
      },
    },
    component: () =>
      lazyLoadView(import('@src/modules/documents/views/documents-nav-bar')),
    children: [
      {
        path: 'geral',
        name: 'documents.overview',
        component: () =>
          lazyLoadView(
            import('@src/modules/documents/views/documents-overview')
          ),
      },
      /* {
                path: 'modelos',
                name: 'documents.templates',
                component: () => lazyLoadView(import('@src/modules/documents/views/documents-templates')),
            }, */
      {
        path: 'gerenciar',
        name: 'documents.manager',
        meta: {
          search: {
            title: 'Gerenciar documentos',
            description: 'Criar e gerenciar documentos e modelos',
            keywords: ['documentos', 'gerenciar', 'modelos', 'contratos'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import('@src/modules/documents/views/documents-manager')
          ),
      },
      {
        path: 'gerenciar/:id_document',
        name: 'documents.manager.document',
        component: () =>
          lazyLoadView(
            import('@src/modules/documents/views/documents-document')
          ),
      },
    ],
  },
]
